export const REALM_SWEDEN = 'se';
export const REALM_NORWAY = 'no';
export const REALM_FINLAND = 'fi';
export const REALM_UK = 'uk';
export const REALM_USA = 'us';
export const REALM_GERMANY = 'de';
export const REALM_FRANCE = 'fr';
export const REALM_NETHERLANDS = 'nl';

export const COUNTRY_CODE_SWEDEN = 'se';
export const COUNTRY_CODE_UK = 'uk';

export type Realm =
  | typeof REALM_SWEDEN
  | typeof REALM_NORWAY
  | typeof REALM_FINLAND
  | typeof REALM_UK
  | typeof REALM_USA
  | typeof REALM_GERMANY
  | typeof REALM_FRANCE
  | typeof REALM_NETHERLANDS;

export const countryLocale: Record<Realm, string> = {
  de: 'de',
  fi: 'fi',
  fr: 'fr',
  no: 'nb',
  nl: 'nl',
  se: 'sv',
  uk: 'en-GB',
  us: 'en-US',
};

export const timezonesByRealm: Record<Realm, string> = {
  de: 'Europe/Berlin',
  fi: 'Europe/Helsinki',
  fr: 'Europe/Paris',
  no: 'Europe/Oslo',
  nl: 'Europe/Amsterdam',
  se: 'Europe/Stockholm',
  uk: 'Europe/London',
  us: 'America/New_York',
};
